// Code review - Completed
// Documentation - Completed
import { useState, useEffect } from "react";
import { districtMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import DistrictPopup from "../popup-containers/DistrictPopup";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
const DistrictMaster = () => {
  const location1 = useLocation();
  //All bind dropdown value and bind data value useState hooks handling.

  const [bindStateDropDown, setBindStateDropDown] = useState([]);
  const [bindDistrictMasterDatas, setBindDistrictMasterDatas] = useState([]);

  //All visible functionality useState hooks handling.
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // SDP Master insert and edit useState hooks handling .
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");

  const [district, setDistrict] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [mstDistrictId, setMSTDistrictId] = useState("");

  const createdBy = sessionStorage.getItem("createdBy");

  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  const [districtMasterData, setDistrictMasterData] = useState("");

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    DistrictMasterData();
    setState("");
    setDistrict("");
    setDistrictError("");
    setStateError("");
    setIsLoading(false);
  };

  // ✅ Reusable filter helper
  const filterBlocked = (data) =>
    (data || []).filter((item) => item.BlockedBy === null);

  useEffect(() => {
    DistrictMasterData();
  }, []);
  const DistrictMasterData = async () => {
    try {
      setIsLoading(true);

      // Fetch both APIs in parallel
      const [statesResponse, districtResponse] = await Promise.all([
        BindAPI("StateAPI/GetState"),
        BindAPI("DistrictAPI/BindDistrictMaster"),
      ]);

      // ✅ States
      const statesData = filterBlocked(statesResponse?.data?.Table).map(
        (item) => ({
          value: item.MstStateId,
          label: item.StateName_en,
        })
      );
      setBindStateDropDown(statesData);

      // ✅ Districts
      setBindDistrictMasterDatas(districtResponse?.data?.Table);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setState(bindDistrictMasterDatas[rowIndex].MstStateId);
    setDistrict(bindDistrictMasterDatas[rowIndex].District_en);
    setMSTDistrictId(bindDistrictMasterDatas[rowIndex].MstDistrictId);
  };

  const handleDistrict = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setDistrictMasterData(bindDistrictMasterDatas[rowIndex]);
    const DistrictData = bindDistrictMasterDatas[rowIndex];
    //State DropDown Value Start
    const stateDropDownValue = bindStateDropDown.find(
      (item) => item.value === DistrictData.MstStateId
    );
    const editStateDropDownValue = {
      value: DistrictData.MstStateId,
      label: stateDropDownValue ? stateDropDownValue.label : "Unknown",
    };
    //State DropDown Value End

    const autoDropDownValues = [editStateDropDownValue];
    setPopUpDropDownData(autoDropDownValues);
  };



  const districtMasterHeader2 = [
    { title: "S.No", field: "SNo" },
    { title: "MstDistrictId", field: "MstDistrictId" },
    { title: "Country", field: "CountryName_en" },
    { title: "State", field: "StateName_en" },
    { title: "District_en", field: "District_en" },
    { title: "District_ta", field: "District_en" },
    { title: "District_hi", field: "District_en" },
    { title: "District_mr", field: "District_en" },
    { title: "District_gu", field: "District_en" },
    
    { title: "District_kn", field: "District_en" },
    { title: "District_ml", field: "District_en" },
    
    
    { title: "District_te", field: "District_en" },
    { title: "District_bn", field: "District_en" },
    { title: "District_or", field: "District_en" },
    // { title: "SDP", field: "SDP_en" },
    // { title: "Area", field: "AreaName_en" },
    // { title: "Area Code", field: "AreaCode" },
    // { title: "Email", field: "AreaEmail" },
    { title: "Created By", field: "CreatedByName" }, // ✅
  ];


  const handleExport = async () => {
    try {
      const districtResponse = await BindAPI(
        "DistrictAPI/ BindDistrictMasterExcel"
      );

      const rows = districtResponse?.data?.Table || [];

      if (rows.length === 0) {
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }

      // ✅ pass only string headers
      exportDistrictData(
        districtMasterHeader2.map((col) => col.title),
        rows
      );
    } catch (error) {
      console.error("District Excel Export Error:", error);
      toast.error("Failed to export District data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportDistrictData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "District Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const style = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: style },              // S.No
        { v: row.MstDistrictId, s: style },     // Country
        { v: row.CountryName_en, s: style },     // Country
        { v: row.StateName_en, s: style },       // State
        { v: row.District_en, s: style },        // District      // State
        { v: row.District_ta, s: style },        // State
        { v: row.District_hi, s: style },        // State
        { v: row.District_bn, s: style },        // State
        { v: row.District_kn, s: style },        // State
        { v: row.District_ml, s: style },        // State
        { v: row.District_gu, s: style },        // State
        { v: row.District_mr, s: style },        // State
        { v: row.District_te, s: style },        // State
        { v: row.District_or, s: style },
        { v: row.CreatedByName, s: style },      // Created By
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 20 },  // Country
      { width: 20 },  // Country
      { width: 25 },  // State
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // District
      { width: 30 },  // Created By
    ];

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "District Master");
    XLSX.writeFile(wb, "District_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };


  const handleSubmit = async (items, flag) => {

    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // validation start
      let stateValidate = "";
      let districtValidate = "";

      districtValidate = district ? "" : "Enter District";

      stateValidate = state ? "" : "Select a State";
      setStateError(stateValidate);
      setDistrictError(districtValidate);
      if (stateValidate || districtValidate) {
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
      // Validation end

      if (!stateValidate && !districtValidate) {
        setIsOpen(false);
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];
        const translatedTexts = [];
        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(district, i);
          translatedTexts.push(
            translateText.data.data.translations[0].translatedText
          );
        }
        const data = [
          {
            mstDistrictId: mstDistrictId ? mstDistrictId : 0,
            mstCountryId: 1,
            mstStateId: state,
            district_en: district,
            district_ta: translatedTexts[0],
            district_hi: translatedTexts[1],
            district_mr: translatedTexts[2],
            district_gu: translatedTexts[3],
            district_kn: translatedTexts[4],
            district_ml: translatedTexts[5],
            district_te: translatedTexts[6],
            district_bn: translatedTexts[7],
            district_or: translatedTexts[8],
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(data, "DistrictAPI/IUDDistrict");
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("District data added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add District data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("District data updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update District data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = [
        {
          mstDistrictId: bindDistrictMasterDatas[items].MstDistrictId,
          createdBy: createdBy,
          flag: flag,
        },
      ];
      const response = await IUDAPI(data, "DistrictAPI/IUDDistrict");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].Result === "D") {
          toast.success("District data deleted successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to delete District data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].Result === "B") {
          toast.success("District data blocked successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to block District data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].Result === "UB") {
          toast.success("District data unblocked successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to unblock District data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };
  useEffect(() => {
    if (location1.pathname == "/districtmaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location1]);

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {visibleTable && (
        <GridPage
          title={"District Master"}
          header={districtMasterHeader}
          records={bindDistrictMasterDatas}
          handleEdit={handleEdit}
          handleExportBtn={true}
          handleExport={handleExport}
          handleAction={handleDistrict}
          showAdd={showadd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <div class="border-black">
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="District Master"
            />
          </div>
          <div class="mx-auto md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <AutoDropDown
                      classStar="text-red-500"
                      classDiv="hidden"
                      title={"Country"}
                      options={[]}
                      selectedOption={country}
                      placeholder={"Select"}
                      name={"country"}
                      controlFunc={(value) => {
                        setCountry(value);
                      }}
                      Class="custom-class"
                      disabled="false"
                      tabIndex="1"
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="State"
                      options={bindStateDropDown}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindStateDropDown.find(
                        (x) => x.value == state
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setState(value.value);
                        setStateError(value ? "" : "Select a State");
                      }}
                      controlFuncBlur={() => {
                        setStateError(state ? "" : "Select a State");
                      }}
                      errorMessage={stateError}
                      setError={setStateError}
                    />

                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title="District"
                      name={"district"}
                      maxLength={100}
                      content={district}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setDistrict(value);
                        setDistrictError(
                          value.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(value)
                              ? "" // No error if the input is valid
                              : ""
                            : "Enter District" // Error message if the input is empty
                        );
                      }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setDistrict(trimmedValue);
                        setDistrictError(
                          trimmedValue.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(trimmedValue)
                              ? "" // No error if the input is valid
                              : "Only single spaces between words allowed"
                            : "Enter District" // Error message if the input is empty
                        );
                      }}
                      errorMessage={districtError}
                    />
                  </form>
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleDistrict}
      >
        <div>
          <PopUpScreenTitle
            title="District Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <DistrictPopup data={districtMasterData} data2={popUpDropDownData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default DistrictMaster;
